const FI_DATA_URL = 'https://api2.simplize.vn/api/company/view/fi-data';
const BATCH_SIZE = 50;

async function fetchBatch(tickers) {
    const res = await fetch(FI_DATA_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tickers }),
    });
    if (!res.ok) throw new Error(`fi-data fetch failed: ${res.status}`);
    const payload = await res.json();
    return Array.isArray(payload?.data) ? payload.data : [];
}

function chunk(arr, size) {
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
}

export async function fetchFiData(tickers) {
    const unique = [...new Set((tickers || []).filter(Boolean).map((t) => String(t).toUpperCase()))];
    if (!unique.length) return {};
    const chunks = chunk(unique, BATCH_SIZE);
    const results = await Promise.all(chunks.map(fetchBatch));
    const out = {};
    for (const rows of results) {
        for (const r of rows) {
            if (!r?.ticker) continue;
            out[r.ticker.toUpperCase()] = r;
        }
    }
    return out;
}
